<template>
  <div class="home">
<!--    Menu -->
    <div id="menu-shadow" class="menu-frame" :class="handleMenuState" @click="toggleMenu($event)">
      <div class="menu-container">
        <div class="menu-top">
          <img src="../assets/fulllogo.png">
          <div class="my-username"><span></span>Max24</div>
          <div class="balance"><span></span>Balance: 128LC</div>
          <div class="purcheCoins"><span>Buy LiliCoins</span></div>
        </div>
        <div class="menu-bottom">
          <div class="menu-element"><span id="inbox"></span>Posteingang</div>
          <div class="menu-element"><span id="liliSecrets"></span>LiliSecrets</div>
          <div class="menu-element"><span id="my-models"></span>Meine Models</div>
          <div class="menu-element"><span id="promotions"></span>Promotions</div>
          <div class="menu-element"><span id="languages"></span>Sprachen</div>
          <div class="menu-element"><span id="help"></span>Help Center</div>
          <div class="menu-element"><span id="terms-conditions"></span>Terms & Conditions</div>
        </div>
      </div>
    </div>

<!--    the screenview-->
    <div class="media" @click="videoPlayer($event)" id="mediaBox">
      <span v-for="(item) in allMedia">
        <video ref="currentVideo" v-if="item.type === 'video'" playsinline loop id="myVideo" v-bind:style="{zIndex: item.index*-1}" v-bind:class="animationClassHandler(item.index, item.type)">
          <source :src="require('../assets/' + item.src)" type="video/mp4">
        </video>
        <div v-if="item.type !== 'video' && !item.multiple" v-bind:style="{backgroundImage: 'url(' + require('../assets/' + item.src) + ')', zIndex: item.index*-1}"
             class="feedImage" v-bind:class="animationClassHandler(item.index, item.type)" ></div>
        <div v-else-if="item.type !== 'video' && item.multiple" v-bind:style="{zIndex: item.index*-1}"
             class="collage" v-bind:class="animationClassHandler(item.index, item.type)" >
          <div class="collage-slider" v-bind:style="{left: collageLeftPosition+'%'}">
            <span class="collage-placeholder" v-bind:style="{backgroundImage: 'url(' + require('../assets/' + item.src) + ')'}"></span>
            <span v-for="(collageItem) in item.others" class="collage-picture" v-bind:style="{backgroundImage: 'url(' + require('../assets/' + collageItem) + ')'}"></span>
          </div>
        </div>
      </span>

      <div v-if="currentMedia.type === 'video' && !isVideoPlaying" class="play-btn"><svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.4118 14.8073L9.98066 0.910789C8.92972 0.313837 7.74179 0 6.53314 0C5.3245 0 4.13656 0.313837 3.08562 0.910789C2.05822 1.61117 1.23384 2.5703 0.69577 3.69128C0.1577 4.81225 -0.0750032 6.05538 0.0211651 7.29508V34.9178C-0.0706442 36.1569 0.163999 37.3985 0.701696 38.5187C1.23939 39.6389 2.06136 40.5986 3.08562 41.3021C4.0354 41.8744 5.12646 42.1692 6.23521 42.1533C7.54135 42.131 8.8241 41.803 9.98066 41.1957L37.4118 27.3418C41.4765 25.2137 42.0724 22.5748 42.0724 21.1277C42.0724 19.6806 41.4765 16.8715 37.4118 14.8073ZM35.4753 23.4473L8.06537 37.3438C7.66114 37.6114 7.19695 37.7748 6.71422 37.8193C6.23149 37.8639 5.74523 37.7883 5.29885 37.5992C4.92121 37.2707 4.63042 36.8541 4.45224 36.3864C4.27406 35.9187 4.21399 35.4143 4.27736 34.9178V7.12483C4.21399 6.62835 4.27406 6.1239 4.45224 5.65618C4.63042 5.18846 4.92121 4.77191 5.29885 4.44343C5.55957 4.2979 5.85161 4.21759 6.15008 4.20934C6.79155 4.23498 7.4182 4.40986 7.98025 4.72008L35.4753 18.6166C36.9224 19.3401 37.8162 20.2765 37.8162 21.0213C37.8162 21.7661 36.9224 22.7025 35.4753 23.4473Z" fill="white"/>
      </svg>
      </div>
      <div class="home-top">
        <div class="menu-icon-container">
          <span class="menu-icon" @click="toggleMenu($event)"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                  width="48" height="48"
                                  viewBox="0 0 172 172"
                                  style=" fill:#000000;"><defs><linearGradient x1="43.2365" y1="0.2365" x2="125.02608" y2="82.02608" gradientUnits="userSpaceOnUse" id="color-1_Rdp3AydLFY2A_gr1"><stop offset="0.237" stop-color="#c7636f"></stop><stop offset="0.85" stop-color="#c7636f"></stop></linearGradient><linearGradient x1="43.2365" y1="43.2365" x2="125.02608" y2="125.02608" gradientUnits="userSpaceOnUse" id="color-2_Rdp3AydLFY2A_gr2"><stop offset="0.237" stop-color="#c7636f"></stop><stop offset="0.85" stop-color="#c7636f"></stop></linearGradient><linearGradient x1="43.2365" y1="86.2365" x2="125.02608" y2="168.02608" gradientUnits="userSpaceOnUse" id="color-3_Rdp3AydLFY2A_gr3"><stop offset="0.237" stop-color="#c7636f"></stop><stop offset="0.85" stop-color="#c7636f"></stop></linearGradient></defs><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M154.08333,53.75h-136.16667c-3.94167,0 -7.16667,-3.225 -7.16667,-7.16667v-7.16667c0,-3.94167 3.225,-7.16667 7.16667,-7.16667h136.16667c3.94167,0 7.16667,3.225 7.16667,7.16667v7.16667c0,3.94167 -3.225,7.16667 -7.16667,7.16667z" fill="url(#color-1_Rdp3AydLFY2A_gr1)"></path><path d="M154.08333,96.75h-136.16667c-3.94167,0 -7.16667,-3.225 -7.16667,-7.16667v-7.16667c0,-3.94167 3.225,-7.16667 7.16667,-7.16667h136.16667c3.94167,0 7.16667,3.225 7.16667,7.16667v7.16667c0,3.94167 -3.225,7.16667 -7.16667,7.16667z" fill="url(#color-2_Rdp3AydLFY2A_gr2)"></path><path d="M154.08333,139.75h-136.16667c-3.94167,0 -7.16667,-3.225 -7.16667,-7.16667v-7.16667c0,-3.94167 3.225,-7.16667 7.16667,-7.16667h136.16667c3.94167,0 7.16667,3.225 7.16667,7.16667v7.16667c0,3.94167 -3.225,7.16667 -7.16667,7.16667z" fill="url(#color-3_Rdp3AydLFY2A_gr3)"></path></g></g></svg></span>
          <span class="content-options">Folge ich  |  Entdecken</span>
          <span class="search"></span>
        </div>
      </div>
      <div class="home-bottom" id="home-bottom">
        <div v-if="currentMedia.type !== 'stream'"  class="caption-container">
          <span v-if="currentMedia.multiple" class="collage-amount"><div v-bind:class="collageLeftPosition==0 ? 'active-picture' : ''"></div><div v-bind:class="collageLeftPosition==-100 ? 'active-picture' : ''"></div><div></div><div></div></span>
          <span v-else class="frameSubstitute"></span>
          <span class="profile-tag">{{currentMedia.profile}}</span>
          <span class="media-caption">{{currentMedia.caption}}</span>
          <span class="see-more">Mehr anzeigen.</span>
        </div>
        <div v-else class="join-stream-container">
          <div class="join-stream" @click="goToStream()"><span style="font-weight: bold; font-size: 1.2rem">LIVE</span><span>Join now</span></div>
        </div>
        <div class="options-container" :class="handleStream">
          <span class="profile-option" v-bind:style="{backgroundImage: 'url(' + require('../assets/' + currentMedia.profilePicture) + ')'}" @click="goToProfile()">
            <div class="profile-icon"></div>
          </span>
          <span class="subscribe-option"></span>
          <span v-if="currentMedia.type !== 'stream'" class="gift-option"></span>
          <span v-if="currentMedia.type !== 'stream'" class="like-option" v-bind:class="likeStatus==='like-active-icon.png'? 'animateLike': ''" v-bind:style="{backgroundImage: 'url(' + require('../assets/' + likeStatus) + ')'}" @click="contentLiked()"></span>
          <span v-if="currentMedia.type !== 'stream'" class="comment-option"></span>
          <span class="more-option">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="35" height="35"
                 viewBox="0 0 172 130"
                 style=" fill:#000000;"><defs><linearGradient x1="85.98986" y1="21.49454" x2="85.9924" y2="150.50293" gradientUnits="userSpaceOnUse" id="color-1_K0l4dwcsMaJa_gr1"><stop offset="0" stop-color="#ffffff"></stop><stop offset="1" stop-color="#ffffff"></stop></linearGradient></defs><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="url(#color-1_K0l4dwcsMaJa_gr1)"><path d="M107.5,103.91667h39.41667c1.97902,0 3.58333,-1.60431 3.58333,-3.58333v-28.66667c0,-1.97902 -1.60431,-3.58333 -3.58333,-3.58333h-39.41667c-1.97902,0 -3.58333,-1.60431 -3.58333,-3.58333v-39.41667c0,-1.97902 -1.60431,-3.58333 -3.58333,-3.58333h-28.66667c-1.97902,0 -3.58333,1.60431 -3.58333,3.58333v39.41667c0,1.97902 -1.60431,3.58333 -3.58333,3.58333h-39.41667c-1.97902,0 -3.58333,1.60431 -3.58333,3.58333v28.66667c0,1.97902 1.60431,3.58333 3.58333,3.58333h39.41667c1.97902,0 3.58333,1.60431 3.58333,3.58333v39.41667c0,1.97902 1.60431,3.58333 3.58333,3.58333h28.66667c1.97902,0 3.58333,-1.60431 3.58333,-3.58333v-39.41667c0,-1.97902 1.60431,-3.58333 3.58333,-3.58333z"></path></g></g></svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "home",
        data: function () {
          return {
            allMedia: [
              {type: "image", multiple: false, others:[], src: "RL-Picture.png", index: 0, profile: "@ashley9x", caption: "Feeling beautiful <3", profilePicture: "profile1.png"},
              {type: "collage", multiple: true, others:["RL-Collage2.png"], src: "RL-Collage1.png", index: 1, profile: "@blonde_24", caption: "New secret pic. It get’s very naughty guys!", profilePicture: "profile2.png"},
              {type: "video", multiple: false, others:[], src: "FeedVideo.mp4", index: 2, profile: "@Camila.RL", caption: "Check it out! My new video!!!! With the faboulus @Jennyxx.", profilePicture: "profile3.png"},
              {type: "stream", multiple: false, others:[], src: "stream1preview.jpg", index: 3, profile: "", caption: "", profilePicture: "profile4.png"},
            ],
            isMenuOpen: false,
            isVideoPlaying: false,
            touchStartPosition: {Y:"", X:""},
            currentVideo: "",
            likeStatus: "like-icon.png",
            collageLeftPosition: 0
          }
        },
      created () {
        window.addEventListener('touchstart', this.handleTouchStart);
        window.addEventListener('touchend', this.handleTouchEnd);
      },
      destroyed () {
        window.removeEventListener('touchstart', this.handleTouchStart);
        window.removeEventListener('touchend', this.handleTouchEnd);
      },
      computed:{
        handleStream(){
          if(this.currentMedia.type === "stream") return "isStream";
          else return "";
        },
        handleMenuState(){
          if(this.isMenuOpen) return "active";
          else return "";
        },
        currentMedia(){
          var result = this.allMedia.filter(obj => {
            return obj.index === 0
          })
          return result[0];
        },


      },
      methods: {
        animationClassHandler(index, type){
          if(index === this.allMedia.length-1)return "lastInRow";

          if(type === "video"){
            if(index === 0)return "animationVideo";
          }else{
            if(index === 0)return "animationImage";
          }
        },
        contentLiked(){
          this.likeStatus = "like-active-icon.png"
        },
        goToStream() {
          this.$router.push('/stream');
        },
        goToProfile() {
          this.$router.push('/profile');
        },
        toggleMenu(event){
          event.stopPropagation();
          if(event.target.id === "menu-shadow"){
            this.isMenuOpen = false;
            return;
          }
          this.isMenuOpen = true
        },
        videoPlayer(event){
          event.stopPropagation();
          if(this.currentMedia.type !== "video") return
          console.log("event:", event.target.id)
          if(event.target.id === "myVideo" || event.target.id === "home-bottom" ) {
            // var video = this.$refs.currentVideo; --> the most optimal way would be with a ref but didn't get it to work and left it to save time.
            if (document.getElementById('myVideo').paused) {
              document.getElementById('myVideo').play();
              this.isVideoPlaying = true;
            } else {
              document.getElementById('myVideo').pause();
              this.isVideoPlaying = false;
            }
          }
          return;
        },
        handleTouchStart (e) {
          this.touchStartPosition.Y = e.touches[0].clientY;
          this.touchStartPosition.X = e.touches[0].clientX;
        },
        handleTouchEnd(e){
          var touchEndPosition = {
            Y: e.changedTouches[0].clientY,
            X: e.changedTouches[0].clientX,
          }

          var differenceY;
          if(this.touchStartPosition.Y >= touchEndPosition.Y){
            differenceY = this.touchStartPosition.Y - touchEndPosition.Y;
          }else{
            differenceY = touchEndPosition.Y - this.touchStartPosition.Y;
          }

          var differenceX;
          if(this.touchStartPosition.X >= touchEndPosition.X){
            differenceX = this.touchStartPosition.X - touchEndPosition.X;
          }else{
            differenceX = touchEndPosition.X - this.touchStartPosition.X;
          }

          if(differenceY >= differenceX){
            if(this.touchStartPosition.Y > touchEndPosition.Y+20){
              this.slide_down();
            }else if(this.touchStartPosition.Y < touchEndPosition.Y-20){
              this.slide_up();
            }
          }
          else{
            if(!this.currentMedia.multiple)return;
            if(this.touchStartPosition.X > touchEndPosition.X+20){
              this.slide_right();
            }else if(this.touchStartPosition.X < touchEndPosition.X-20){
              this.slide_left();
            }
          }
        },
        slide_down(){
          var last = this.allMedia[this.allMedia.length-1].index;
          for (var i= this.allMedia.length-1; i>=0; i--){
            try {
              this.allMedia[i].index = this.allMedia[i-1].index;
            } catch (error) {
              this.allMedia[i].index = last;
            }
          }
          //reset all previous data
          this.collageLeftPosition = 0;
          if (!document.getElementById('myVideo').paused) {
            document.getElementById('myVideo').pause();
            this.isVideoPlaying = false;
          }
          this.likeStatus= "like-icon.png";
        },
        slide_up(){
          var first = this.allMedia[0].index;
          for (var i= 0; i<this.allMedia.length; i++){
            try {
              this.allMedia[i].index = this.allMedia[i+1].index;
            } catch (error) {
              this.allMedia[i].index = first;
            }
          }
          //reset all previous data
          this.collageLeftPosition = 0;
          if (!document.getElementById('myVideo').paused) {
            document.getElementById('myVideo').pause();
            this.isVideoPlaying = false;
          }
          this.likeStatus= "like-icon.png";
        },
        slide_right(){
          this.collageLeftPosition = -100;
        },
        slide_left(){
          this.collageLeftPosition = 0;
        }
      }

    }
</script>

<style scoped>
  * {
    font-family: "Helvetica";
  }
  html, body {
    width: 100%;
    height:100%;
    border: 0;
    overflow:hidden;
  }

  .home{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .media{
    width: 100%;
    height: 100%;
  }
  .feedImage{
    position: absolute;
    left: 0;
    bottom:0;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .lastInRow{
    opacity: 1!important;
  }
  .animationImage{
    animation-name:slideupImage;
    animation-duration:0.4s;
    animation-fill-mode:forwards;
    animation-timing-function:ease-out;
  }
  .animationVideo{
    animation-name:slideupVideo;
    animation-duration:0.4s;
    animation-fill-mode:forwards;
    animation-timing-function:ease-out;
  }
  #myVideo {
    object-fit: fill;
    position: absolute;
    bottom: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
    opacity: 0;
  }
  @keyframes slideupImage {
    0%{opacity: 0;bottom:-100%}
    25%{opacity: 0.8;}
    100%{bottom:0;opacity: 1;}
  }
  @keyframes slideupVideo {
    0%{opacity: 0;bottom:-100%}
    25%{opacity: 0.8;}
    100%{bottom:-50%;opacity: 1;}
  }

  .menu-frame{
    position: absolute;
    display: none; /*default*/
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.35);
    z-index: 99;
  }
  .menu-frame.active{
    display: block;
  }
  .menu-container{
    position: fixed;
    z-index: 100;
    height: 100%;
    width: 75%;
    background-color: #C7636F;
  }
  .menu-top{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 30px 0px;
    width: 100%;
    height: 40%;
    background-color: white;
    box-shadow: 1px 5px rgba(0,0,0,0.15);
  }
  .menu-top img {
    width: 80%;
  }

  .my-username{
    display: flex;
    align-items: center;
  }
  .my-username span{
    display: inline-block;
    width: 8vw;
    height: 8vw;
    background-image: url("../assets/user.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin: 0vw 4vw;
  }
  .balance{
    display: flex;
    align-items: center;
  }
  .balance span{
    display: inline-block;
    width: 8vw;
    height: 8vw;
    background-image: url("../assets/wallet.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin: 0vw 4vw;
  }
  .purcheCoins{
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    color: white;
  }
  .purcheCoins span{
    padding: 2vw 10vw;
    background-color: #918FFD;
    border-radius: 3vw;
    box-shadow: 2px 3px rgba(0,0,0,0.15);
  }
  .menu-bottom{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 3vw 0vw;
    height: 60%;
  }
  .menu-bottom .menu-element{
    display: flex;
    align-items: center;
    height: 13.5%;
    color: white;
  }

  .menu-bottom .menu-element span{
    display: inline-block;
    width: 8vw;
    height: 8vw;
    background-size: cover;
    background-repeat: no-repeat;
    margin: 0vw 8vw 0vw 4vw;
  }

  #inbox{
    background-image: url("../assets/inbox-icon.png");
  }
  #liliSecrets{
    background-image: url("../assets/white-lock-icon.png");
  }
  #my-models{
    background-image: url("../assets/my-models-icon.png");
  }
  #promotions{
    background-image: url("../assets/discount.png");
  }
  #languages{
    background-image: url("../assets/language-icon.png");
  }
  #help{
    background-image: url("../assets/support-icon.png");
  }
  #terms-conditions{
    background-image: url("../assets/TermsAndConditions-icon.png");
  }



  .play-btn{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -1rem;
    margin-left: -1rem;
    width: 2rem;
    height: 2rem;
    animation-name:button-appear;
    animation-duration:0.5s;
    animation-fill-mode:forwards;
    animation-timing-function:ease-out;
  }

  @keyframes button-appear {
    0%{opacity: 0}
    75%{opacity: 0}
    100%{opacity: 1}
  }
  .home-top{
    position: absolute;
    width: 100%;
    height: 12%;

    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .menu-icon-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    top: 0;
    width: 90%;
    height: 100%;
  }
    .menu-icon-container span{
      width: 20%;
      height: 50%;
    }
    .menu-icon-container .menu-icon svg{
      display: block;
      margin: 0 auto;
    }

    .menu-icon-container .content-options{
      display: inline-flex;
      align-items: center;
      width: 40%;
      font-size: 1rem;
      white-space: nowrap;
      color: white;
    }
    .menu-icon-container .search{
      background-image: url("../assets/search-icon.png");
      background-repeat: no-repeat;
      background-size: 35px 35px;
      background-position-y: center;
      background-position-x: center;
    }
  .home-bottom{
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    height: 60%;
  }
  .options-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 20%;
    height: 100%;
  }
    .options-container > span{
      background-color: rgba(0, 0, 0, 0.35);
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
    }
    .options-container span:first-child{
      transform: scale(1.2);
      margin-top: 10px;
    }
    .options-container span:last-child{
      margin-bottom: 30px;
    }

  .profile-option{
    background-repeat: no-repeat;
    background-size: cover;
    border: 4px solid #C7636F;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .profile-icon{
    background-image: url("../assets/profile-icon.png");
    background-repeat: no-repeat;
    background-size: 60%;
    background-position-y: center;
    background-position-x: center;
    position: absolute;
    bottom: -20%;
    background-color: #C7636F;
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
  }

  .subscribe-option{
    background-image: url("../assets/crown-icon.png");
    background-repeat: no-repeat;
    background-size: 85%;
    background-position-y: center;
    background-position-x: center;
    border: 4px solid #C7636F;
    background-color: #814048 !important;
  }
  .gift-option{
    background-image: url("../assets/gift-icon.png");
    background-repeat: no-repeat;
    background-size: 65%;
    background-position-y: center;
    background-position-x: center;
  }

  .like-option{
    background-image: url("../assets/like-icon.png");
    background-repeat: no-repeat;
    background-size: 65%;
    background-position-y: center;
    background-position-x: center;
  }

  .animateLike{
    animation-name:likeAnimation;
    animation-duration:0.5s;
    animation-fill-mode:forwards;
    animation-timing-function:ease-out;
  }
  @keyframes likeAnimation {
    0%{transform: scale(0.8)}
    50%{transform: scale(1.2)}
    100%{transform: scale(1)}

  }
  .comment-option{
    background-image: url("../assets/comment-icon.png");
    background-repeat: no-repeat;
    background-size: 65%;
    background-position-y: center;
    background-position-x: center;
  }

  .more-option svg{
    display: block;
    margin: 0 auto;
  }

  .join-stream-container{
    display: flex;
    flex-direction: column;
    width: 70%;
    height: 25%;
  }

  .join-stream{
    position: absolute;
    left: 50%;
    transform: translate(-50%,-30%);
    width: 7rem;
    height: 7rem;
    background-color: #C7636F;
    color: white;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 10px solid white;
  }

  .caption-container{
    display: flex;
    flex-direction: column;
    width: 70%;
    height: 30%;
  }
  .caption-container > span{
    margin-left: 20px;
  }
  .collage{
    position: absolute;
    left: 0;
    bottom:0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .collage-slider{
    position:relative;
    float:left;
    height:100%;
    width:200%;
    left:0;
    -webkit-transition:left 0.5s ease-in-out;
  }
  .collage-placeholder{
    background-repeat: no-repeat;
    background-size: cover;
    position:relative;
    float:left;
    height:100%;
    width:50%;
  }
  .collage-picture{
    background-repeat: no-repeat;
    background-size: cover;
    position:relative;
    float:left;
    height:100%;
    width:50%;
  }

  .collage-amount{
    display: inline-flex;
    margin-bottom: 5px;
  }
  .collage-amount > div{
    margin-right: 5px;
    height: 10px;
  }

  .collage-amount > div:not(.active-picture) {
    width: 10px;
    background-color: white;
    border-radius: 50%;
  }
  .frameSubstitute{
    margin-top: 3vw;
  }
  .active-picture{
    width: 25px;
    background-color: #C7636F;
    border-radius: 30%;
  }
  .profile-tag{
    font-size: 1.5rem;
    color: white;
  }
  .media-caption{
    margin-top: 10px;
    font-size: 0.9rem;
    color: white;
  }
  .see-more{
    font-size: 0.8rem;
    margin-top: 2vw;
    color: #C4C4C4;
  }
  .isStream{
    justify-content: normal;
  }

  .isStream > span{
    margin-bottom: 25px;
  }






</style>



// WEBPACK FOOTER //
// src/components/Home.vue